import React from 'react';
import { RegisterForm } from '@decub8/ui';

import { Content, Meta } from '@src/components';
import OnboardingHeader from '@src/components/OnboardingHeader';
import { useRegister } from '@src/hooks/pages/useRegister';

const Register: React.FC = () => {
    const props = useRegister();

    return (
        <Content>
            <Meta title="Sign up" />
            <OnboardingHeader current_step={0} />
            <div className="flex justify-center pb-[60px]">
                <RegisterForm {...props} />
            </div>
        </Content>
    );
};

export default Register;
